export default __webpack_public_path__ + "static/media/logo_PdC_62_depart.51523433.png";